import React from "react";
import _ from "lodash";
import MUIDataTable from "mui-datatables";

const noFilterAndNoSort = {
	filter: false,
	sort: false
};

const columns = [
	{
		name: "resource",
		label: "Recurso",
		options: noFilterAndNoSort
	},
	{
		name: "indicator",
		label: "Indicador",
		options: noFilterAndNoSort
	},
	{
		name: "typing",
		label: "Tipificación",
		options: noFilterAndNoSort
	},
	{
		name: "years",
		label: "Año",
		options: noFilterAndNoSort
	},
	{
		name: "value",
		label: "Valor",
		options: noFilterAndNoSort
	},
	{
		name: "probability",
		label: "Probabilidad",
		options: noFilterAndNoSort
	},
	{
		name: "description",
		label: "Descripción",
		options: noFilterAndNoSort
	}
];

const defaultOptions = {
	filterType: "dropdown",
	display: "excluded",
	selectableRows: false,
	resizableColumns: false,
	responsive: "scroll",
	serverSide: true,
	rowsPerPageOptions: [50, 100, 200],
	search: false,
	filter: false,
	print: false,
	download: false,
	sort: false,
	viewColumns: false
};

const TYPING = {
	MEN: "Hombres",
	WOMEN: "Mujeres",
	RURAL: "Rural",
	URBAN: "Urbano",
	TOTAL: "Total"
};

function mapItems(item) {
	return {
		resource: _.get(item, "resource.name", ""),
		indicator: _.get(item, "indicator.name", ""),
		typing: _.get(TYPING, item.typing, ""),
		years: `${_.get(item, "years", "").lower}-${
			_.get(item, "years", "").upper
		}`,
		value: _.get(item, "value", ""),
		probability: _.get(item, "probability", ""),
		description: _.get(item, "description", "")
	};
}

const DataTableEvents = ({ data, filters, total, onChange, openPanel }) => {
	const { limit, page } = filters;
	const items = _.map(data, mapItems);
	const rowsPerPage = limit;

	const onChangeFilter = (values) => {
		const newFilter = {
			...filters,
			...values
		};
		onChange(newFilter);
	};

	const options = {
		...defaultOptions,
		rowsPerPage,
		count: total,
		page,
		onTableChange: (action, tableState) => {
			if (openPanel) {
				onChangeFilter({
					limit: tableState.rowsPerPage,
					skip: tableState.page * limit,
					page: tableState.page
				});
			}
		}
	};

	return (
		<MUIDataTable
			title="Datos cargados"
			data={items}
			columns={columns}
			options={options}
		/>
	);
};

export default DataTableEvents;



// WEBPACK FOOTER //
// ./src/components/admin/carto/stats/stats-datatable.js